import React, {useId, useRef, useState} from 'react';
import Input from './input';

// An optional override: a saved value stays visible until the user explicitly resets it.
export default function OptionalInput({id, name, value = '', label, revealLabel = 'Customise', resetLabel = 'Use Default', defaultText = 'Uses the default', description, inputType = 'text', compactTextClassName = 'text-[13px]', groupClassName = '', onChange = () => {}, disabled, readOnly, required, error, autoFocus, ...inputProps}) {
    const generatedId = useId();
    const inputId = id || `optional-input-${generatedId}`;
    const panelId = `${inputId}-panel`;
    const hasValue = value !== '' && value !== null && value !== undefined;
    const [expanded, setExpanded] = useState(hasValue);
    const showInput = expanded || hasValue || required || Boolean(error) || Boolean(autoFocus);
    const input = useRef(null);
    const reveal = useRef(null);
    const editable = !disabled && !readOnly;
    const linkClass = `${compactTextClassName} font-medium text-primary-700 hover:underline focus-visible:underline`;
    return <div className={`grow ${groupClassName}`}>
        {!showInput && <div className="flex flex-wrap items-baseline justify-between gap-x-3 gap-y-1">
            <span className={`${compactTextClassName} min-w-0 break-words text-gray-500`}>{defaultText}</span>
            {editable && <button ref={reveal} type="button" className={linkClass} aria-expanded={false} aria-controls={panelId} onClick={() => {
                setExpanded(true);
                requestAnimationFrame(() => input.current?.focus());
            }}>{revealLabel}</button>}
            <input type="hidden" name={name} value={value ?? ''} disabled={disabled}/>
        </div>}
        <div id={panelId} hidden={!showInput}>
            {showInput && <>
                <div className="mb-1 flex items-baseline justify-between gap-2">
                    {label && <label className={`text-sm font-semibold ${error && editable ? 'text-error-500' : 'text-gray-700'}`} htmlFor={inputId}>{label}</label>}
                    {editable && !required && <button type="button" className={linkClass} onClick={event => {
                        onChange(event, name, '');
                        setExpanded(false);
                        requestAnimationFrame(() => reveal.current?.focus());
                    }}>{resetLabel}</button>}
                </div>
                <Input {...inputProps} ref={input} id={inputId} name={name} type={inputType} value={value ?? ''}
                    disabled={disabled} readOnly={readOnly} required={required} error={error} onChange={onChange}/>
                {error && typeof error === 'string' && editable
                    ? <p className="mt-1.5 text-xs font-medium text-error-500">{error}</p>
                    : description && <p className="mt-1 mb-0 text-xs text-gray-500">{description}</p>}
            </>}
        </div>
    </div>;
}
OptionalInput.wrapWithInputGroup = false;
OptionalInput.handlesFeedback = true;
